import React from 'react';
import { connect } from 'dva';
import { Link } from 'dva/router';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Spin, Card, Row, Col, Button } from 'antd';
import moment from 'moment-timezone';
import helpers from '../../../utils/helpers';
import { PageHeader, VisitsTable } from '../../../components';
import styles from '../styles.less';
import RecordingsPlayer from '../../RecordingsPlayer';

class LeadPageDetails extends React.Component {
  constructor(props) {
    super(props);

    const urlParams = this.props.match.params;
    this.projectId = urlParams.projectId;
    this.companyId = urlParams.companyId;
    this.visitId = urlParams.visitId;
    this.page = urlParams.page;

    this.state = {
      page: null,
      currentPage: this.page || 1,
    };
  }

  componentDidMount() {
    const { matomo, dispatch } = this.props;

    if (!matomo.leadDetails) {
      dispatch({
        type: 'leads/getDetails',
        payload: {
          projectId: this.projectId,
          leadId: this.companyId,
        },
      }).then(leadDetails => dispatch({
        type: 'matomo/updateStore',
        payload: { leadDetails },
      }));
    }

    if (!matomo.visitDetails.id) {
      dispatch({
        type: 'matomo/getCompanyVisitDetails',
        payload: {
          projectId: this.projectId,
          companyId: this.companyId,
          visitId: this.visitId,
        },
      }).then((resp) => {
        dispatch({
          type: 'matomo/updateStore',
          payload: {
            visitDetails: {
              ...resp,
              campaignName: resp ? resp.campaign_name : null,
              adCampaign: resp ? resp.ad_campaign : null,
            },
          },
        });
      });
    } else {
      this.setPageDetails(matomo, this.state.currentPage);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ currentPage: nextProps.match.params.page });
    this.setPageDetails(nextProps.matomo, nextProps.match.params.page);
  }

  componentDidUpdate(prevProps) {
    if ((this.props.matomo.leadDetails && !prevProps.matomo.leadDetails)
      || ((prevProps.matomo.leadDetails && this.props.matomo.leadDetails)
        && (prevProps.matomo.leadDetails.id !== this.props.matomo.leadDetails.id))) {
      this.props.dispatch({
        type: 'header/update',
        payload: {
          variable: this.props.matomo.leadDetails.company_name,
        },
      });
    }
  }

  setPageDetails(matomo, currentPage) {
    const { page_views_details } = matomo.visitDetails;
    if (page_views_details && page_views_details.length === 0) {
      return;
    }

    const page = page_views_details.find((p) => {
      return p.interaction_position === parseInt(currentPage, 10);
    });

    this.setState({ page });
  }

  getTimeStamp(time) {
    const { user } = this.props.app;
    const tz = moment.tz(time, user.display_timezone);
    return moment(tz).format(user.display_datetime_format);
  }

  getModifiedEvents() {
    const { events } = this.state.page;
    return events.map((event, i) => {
      return {
        date: this.getTimeStamp(event.timestamp),
        category: event.category,
        name: event.name,
        value: event.value,
        position: i,
      };
    });
  }

  getModifiedLinksArrays(array) {
    return array.map((el, i) => {
      return {
        position: i,
        url: <a href={el.url} target="_blank" rel="noopener noreferrer">{el.url}</a>,
        date: this.getTimeStamp(el.timestamp),
      };
    });
  }

  getPageArrays(prop) {
    if (!this.state.page || !this.state.page[prop].length) {
      return null;
    }

    return (
      <VisitsTable
        dataSource={this.getModifiedLinksArrays(this.state.page[prop])}
        rowKey="position"
        title={`Common.${prop.charAt(0).toUpperCase() + prop.slice(1)}`}
      />
    );
  }

  isLxpSessionRecordingsVisible(page) {
    return this.props.app.defaultUiSettings.lxp_session_records && page.uuid;
  }

  cancelAction() {
    this.props.dispatch({
      type: 'app/goToRoute',
      payload: {
        routeName: 'LEAD_VISITS_VISIT_DETAILS',
        companyId: this.companyId,
        visitId: this.visitId,
        projectId: this.projectId,
      },
    });
  }

  render() {
    const { loading, matomo } = this.props;
    const { page, currentPage } = this.state;

    return (
      <div>
        <Spin
          spinning={!!loading.effects['matomo/getCompanyVisitDetails'] || !!loading.effects['leads/getDetails'] || !!loading.effects['leads/loadRecording']}
          className={styles.companySpinContainer}
        >
          {page &&
          <div>
            <Card className="card-multiple card-single">
              <Row type="flex" gutter={{ xs: 8, sm: 16, md: 24 }}>
                <Col xxl={6} xl={8} lg={10} md={24} sm={24} xs={24}>
                  <h4><FormattedMessage id="Grid.Column.PageTitle" /></h4>
                  <div className="text">{page.page.title || page.search.keyword}</div>
                  <h4><FormattedMessage id="Grid.Column.PageUrl" /></h4>
                  <div className="text">
                    {page.page.url && <a className="link" href={page.page.url} target="_blank" rel="noopener noreferrer">{page.page.url}</a>}
                  </div>
                </Col>
                <Col xxl={4} xl={8} lg={10} md={24} sm={24} xs={24}>
                  <h4><FormattedMessage id="Grid.Column.Date" /></h4>
                  <div className="text">
                    {this.getTimeStamp(page.timestamp)}
                  </div>
                  <h4><FormattedMessage id="Common.TotalTimeOnPage" /></h4>
                  <div className="text">
                    {helpers.getTimeFromDuration(page.duration, 'seconds')}
                  </div>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={24} sm={24} xs={24}>
                  {matomo.visitDetails.target_group &&
                  <div>
                    <h4><FormattedMessage id="Grid.Column.TargetGroup" /></h4>
                    <div className="text">
                      <Link className="link" to={`/${this.projectId}/target-groups/${matomo.visitDetails.target_group.id}/edit/`} target="_blank">
                        {matomo.visitDetails.target_group.name}
                      </Link>
                    </div>
                  </div>
                  }
                  {page.dynamic_content.length > 0 &&
                  <div>
                    <h4><FormattedMessage id="Grid.Column.DynamicContent" /></h4>
                    <div className="text">
                      <ul>
                        {page.dynamic_content.map((d, index) => <li key={index}>{d.name}</li>)}
                      </ul>
                    </div>
                  </div>
                  }
                </Col>
              </Row>
            </Card>
            <hr />
            <PageHeader
              onBackToOverview={this.cancelAction.bind(this)}
              backText={'Common.BackToVisitDetails'}
              buttons={matomo.visitDetails.page_views_details.length > 1 &&
              <Row>
                <Col span={24} className={styles.pageBtnsWr}>
                  {currentPage > 1 &&
                  <Link className="link" to={`${parseInt(currentPage, 10) - 1}`}>
                    <Button type="primary">
                      <FormattedMessage id="Common.PreviousPage" />
                    </Button>
                  </Link>
                  }
                  {currentPage < matomo.visitDetails.page_views_details.length &&
                  <Link className="link" to={`${parseInt(currentPage, 10) + 1}`}>
                    <Button type="primary">
                      <FormattedMessage id="Common.NextPage" />
                    </Button>
                  </Link>
                  }
                </Col>
              </Row>
              }
            />
            <hr />
            {this.getPageArrays('downloads')}
            {this.getPageArrays('outlinks')}
            {page && page.events.length > 0 &&
            <VisitsTable
              dataSource={this.getModifiedEvents()}
              rowKey="position"
              title="Grid.Column.Events"
            />}
            {this.isLxpSessionRecordingsVisible(page) &&
            <Card>
              <RecordingsPlayer projectId={this.projectId} uuid={this.state.page.uuid} />
            </Card>}
          </div>
          }
        </Spin>
      </div>
    );
  }
}

export default connect(({ loading, app, matomo, leads }) =>
  ({ loading, app, matomo, leads }))(injectIntl(LeadPageDetails));



// WEBPACK FOOTER //
// ./src/components/Leads/LeadPageDetails/LeadPageDetails.js